export const APP_TITLE = "Photos & Vidéos";
export const JWT_PERIOD = 40 * 60 * 1000;
